export enum CHOOSE_ITEM_CARD_TYPE {
  NORMAL_CARD = 'normalCard',
  HANDLING_CARD = 'handlingCard',
  PICKUP_POINT_CARD = 'pickupPointCard',
}
